export const messages = {
  title: {
    id: 'changePassword.Page.Header',
    defaultMessage: 'Change Your Password',
  },
  description: {
    id: 'changePassword.Page.Description',
    defaultMessage: 'Enter your current password, and then enter and confirm a new password',
  },
  button: {
    id: 'changePassword.Button',
    defaultMessage: 'Change Password',
  },
  placeholder: {
    oldpassword: {
      id: 'changePassword.Placeholder.OldPassword',
      defaultMessage: 'Current password',
    },
    password: {
      id: 'changePassword.Placeholder.Password',
      defaultMessage: 'New password',
    },
    confirmpassword: {
      id: 'changePassword.Placeholder.ConfirmPassword',
      defaultMessage: 'Confirm new password',
    },
  },
};
